import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatRand } from "../../lib/api";

const AdminCustomers = () => {
  const [customers, setCustomers] = useState([]);

  const fetchAll = () => api.get("/admin/customers").then((r) => setCustomers(r.data));

  useEffect(() => { fetchAll(); }, []);

  const toggleRevoke = async (c) => {
    try {
      await api.patch(`/admin/customers/${c.id}`, { membership_revoked: !c.membership_revoked });
      toast.success(c.membership_revoked ? "Membership restored" : "Membership revoked");
      fetchAll();
    } catch (err) {
      toast.error("Could not update");
    }
  };

  const resend = async (c) => {
    try {
      await api.patch(`/admin/customers/${c.id}`, { resend_signup_link: true, is_member: true });
      toast.success("Welcome email resent");
      fetchAll();
    } catch (err) {
      toast.error("Could not resend");
    }
  };

  const remove = async (c) => {
    if (!confirm(`Delete customer ${c.email} permanently?`)) return;
    try {
      await api.delete(`/admin/customers/${c.id}`);
      toast.success("Customer deleted");
      fetchAll();
    } catch (err) {
      toast.error("Could not delete");
    }
  };

  return (
    <div data-testid="admin-customers-page">
      <div className="border-b hairline pb-6 mb-8">
        <div className="overline mb-2">Family</div>
        <h1 className="font-display text-4xl uppercase tracking-tighter">Customers / Members</h1>
      </div>
      <div className="border hairline overflow-x-auto" style={{ background: "#fff" }}>
        <table className="admin-table">
          <thead>
            <tr>
              <th>Name</th><th>Email</th><th>First Purchase</th><th>Orders</th><th>Spent</th><th>Status</th><th></th>
            </tr>
          </thead>
          <tbody>
            {customers.length === 0 ? (
              <tr><td colSpan={7} className="text-black/40 text-center py-8">No customers yet</td></tr>
            ) : customers.map((c) => (
              <tr key={c.id} data-testid={`admin-customer-row-${c.email}`}>
                <td className="font-display">{c.name}</td>
                <td>{c.email}</td>
                <td className="text-xs text-black/55">{c.first_purchase_date ? new Date(c.first_purchase_date).toLocaleDateString() : "—"}</td>
                <td>{c.total_orders}</td>
                <td className="font-display">{formatRand(c.total_spent || 0)}</td>
                <td>
                  {c.membership_revoked ? (
                    <span className="status-pill muted">Revoked</span>
                  ) : c.is_member && c.has_login ? (
                    <span className="status-pill solid">Member</span>
                  ) : c.is_member ? (
                    <span className="status-pill muted">Invited</span>
                  ) : (
                    <span className="status-pill muted">Customer</span>
                  )}
                </td>
                <td>
                  <div className="flex flex-wrap gap-2 justify-end">
                    <button onClick={() => resend(c)} className="btn-ghost" data-testid={`admin-resend-${c.email}`}>Resend Link</button>
                    <button onClick={() => toggleRevoke(c)} className="btn-ghost" data-testid={`admin-revoke-${c.email}`}>
                      {c.membership_revoked ? "Restore" : "Revoke"}
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminCustomers;
